import React from "react";
import { AUDIO_CREATOR, AUDIO_TITLE } from "../data-hooks.js";
import styles from "../statics/styles/audio-scss.js";
const AudioDetails = ({ authorName, title }) => {
  return /* @__PURE__ */ React.createElement("div", { className: styles.audioDetails }, title && /* @__PURE__ */ React.createElement("span", { className: styles.title, "data-hook": AUDIO_TITLE, title }, title), authorName && /* @__PURE__ */ React.createElement("span", { className: styles.authorName, "data-hook": AUDIO_CREATOR, title: authorName }, authorName));
};
var AudioDetails_default = AudioDetails;
export {
  AudioDetails_default as default
};
//# sourceMappingURL=AudioDetails.js.map
